import { gql } from '@apollo/client'

export const GET_BIG_QUERY_BRAND_CATEGORIES = gql`
  query GetBigQueryBrandCategories($input: BrandCategoriesInput!) {
    brandCategories(input: $input) {
      count
      hasMore
      results {
        id
        name
      }
    }
  }
`
